import { faEye } from '@fortawesome/free-regular-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import ActivityLog from '../ActivityLog';
import * as Common from '../Common';
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import FaView from '../FaView';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from '../Picklist';
import Tran_data_unlock_request from '../Tran_data_unlock_request';

const FundTransferInternal = () => {
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');
    const [scrMode, setScrMode] = useState("");
    const [userRight, setUserRight] = useState([]);
    const [userRightStatus, setUserRightStatus] = useState([]);

    const [onceRun, setOnceRun] = useState(false);

    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [isDeleteBoxYN, setDeleteBoxYN] = useState(false);
    const [deleteRemark, setDeleteRemark] = useState("");
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isErrBox, setErrBox] = useState(false);
    const [errText, setErrText] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [headerData, setHeaderData] = useState([]);

    const [radioType, setRadioType] = useState('N');

    const [transactionDate, setTransactionDate] = useState(new Date());
    // const [viewDate, setViewDate] = useState(new Date());
    const [filterFromDate, setFilterFromDate] = useState(new Date());
    const [filterToDate, setFilterToDate] = useState(new Date());
    const [fromSrno, setFromSrno] = useState("");
    const [toSrno, setToSrno] = useState("");

    const [fromBank, setFromBank] = useState(null);
    const [toBank, setToBank] = useState(null);
    const [statusUpdate, setStatusUpdate] = useState('');
    const [refrenceNumber, setRefrenceNumber] = useState('');



    const [currencyCode, setCurrencyCode] = useState("");
    const [outCNDeno, setOutCNDeno] = useState("");
    const [outCNQuantity, setOutCNQuantity] = useState("");
    const [outCNRate, setOutCNRate] = useState("");
    const [outCNAmount, setOutCNAmount] = useState(0);
    const [transactionAmount, setTransactionAmount] = useState(0);
    const [srNo, setSrNo] = useState(0);
    const [lineNo, setLineNo] = useState(0);
    const [viewDate, setViewDate] = useState('');
    const currentDate = new Date();

    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [showActivityLog, setShowActivityLog] = useState(false);

    const [unlockRequestType, setUnlockRequestType] = useState("");
    const [faViewObject, setFaViewObject] = useState({ location: "", trannumber: "", type: "" });
    const [showFaView, setShowFaView] = useState(false);
    const [viewObj, setViewObj] = useState();


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'FUND_TRANSFER_INTERNAL'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                    Common.callApi(Common.apiRight, [sid, 'all', 'FUND_TRANSFER_INTERNAL_STATUS'], function (result) {
                        setUserRightStatus(JSON.parse(result));
                    })
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);
    const handleFromBankChange = (value) => {
        setFromBank(value);
        const currency = value.id.split('^');
        setCurrencyCode(currency[1]);
    }
    const handleToBankChange = (value) => {
        setToBank(value);
        const currency = value.id.split('^');
        setCurrencyCode(currency[1]);
    }

    const list = () => {
        var msg = [], i = 0;
        if (radioType === 'S' && (fromSrno === "" || toSrno === "")) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (radioType === 'S' && fromSrno === "" ? " From." : '');
            msg[i++] = (radioType === 'S' && toSrno === "" ? " To." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                filterRadioType: radioType,
                filterFromDate: Common.dateYMD(filterFromDate),
                filterToDate: Common.dateYMD(filterToDate),
                filterFromSrno: fromSrno,
                filterToSrno: toSrno,
            }
            Common.callApi(Common.apiTransferFundInternal, [sid, 'list', JSON.stringify(obj)], (result) => {
                let resp = JSON.parse(result);
                if (resp.status) {
                    setHeaderData(resp.data);
                } else {
                    setMsgBox(true);
                    setMsgText(resp.msg);
                }
            });
        }
    }


    const addNew = () => {
        var date = Common.dateYMD(transactionDate);
        let today = Common.dateYMD(new Date);
        setViewDate(Common.dateDMY(transactionDate));
        if (date == today) {
            addNewFormResetFields();
        } else {
            const obj = {
                billdate: date,
                location: 0,
                type: 'FTI'
            }
            Common.callApi(Common.apiDataUnlock, [sid, 'addnewunlock', JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                if (resp.msg === "1") {
                    addNewFormResetFields();
                } else {
                    setMsgBox(true);
                    setMsgText(Common.getMessage("MSG0012"));
                }
            });
        }
    }


    const addNewFormResetFields = () => {
        setScrMode('A');
        setOutCNAmount(null);
        setOutCNQuantity("");
        setOutCNDeno("");
        setOutCNRate("");
        setOutCNAmount("");
        setTransactionAmount(0);
        setSrNo(0);
        setFromBank();
        setToBank();
        setRefrenceNumber('')
    }

    const saveData = () => {
        $(".loader").show();
        var isok = true;
        var msg = [], i = 0;
        msg[i++] = Common.getMessage("MSG0006");
        !fromBank && (msg[i++] = "From Bank");
        !toBank && (msg[i++] = "To Bank");
        !transactionAmount && (msg[i++] = "Amount ");
        !refrenceNumber.trim() && (msg[i++] = "Refrence Number ");
        if (isok && i > 1) {
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
            isok = false;
        }
        //check from bank and to bank should not be equal.
        let fromBankArr = fromBank.id.split('^');
        let toBankArr = toBank.id.split('^');
        if (fromBankArr[1] === toBankArr[1] && fromBankArr[2] === toBankArr[2]) {
            $(".loader").hide();
            setMsgText("From bank and to bank should not be same.");
            setMsgBox(true);
            isok = false;
        }
        if (isok) {
            const obj = {
                srno: srNo,
                date: Common.dateYMD(transactionDate),
                amount: transactionAmount,
                fromBank: fromBank,
                toBank: toBank,
                fromGroup: fromBankArr[1],
                fromAccount: fromBankArr[2],
                toGroup: toBankArr[1],
                toAccount: toBankArr[2],
                refrenceNumber: refrenceNumber.trim()
            }
            // $(".loader").show();
            Common.callApi(Common.apiTransferFundInternal, [sid, 'save', JSON.stringify(obj), JSON.stringify(tranAuditTrail)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                if (resp.status) {
                    setHeaderData(resp.data);
                    setScrMode("");
                    expireUnlock();
                } else {
                    setMsgBox(true);
                    setMsgText(resp.msg);
                }
            });
        }
    }


    const viewList = (srno) => {
        setScrMode("Q");
        setSrNo(srno)
        const obj = {
            srno: srno
        }
        Common.callApi(Common.apiTransferFundInternal, [sid, 'view', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            if (resp.status) {
                let data = resp.data[0];
                setViewObj(resp.data[0]);
                setTransactionAmount(data.tfti_amount);
                setViewDate(data.tfti_date);
                setRefrenceNumber(data.tfti_refrence_number);
                setFromBank({
                    id: '^' + data.tfti_from_bank.split(' ').join('^') + '^',
                    label: data.tfti_from_bank
                });
                setToBank({
                    id: '^' + data.tfti_to_bank.split(' ').join('^') + '^',
                    label: data.tfti_to_bank
                });
                setStatusUpdate(data.tfti_status)
            } else {
                setMsgBox(true);
                setMsgText(resp.msg);
            }
        });
    }


    const cancelConfirm = () => {
        if (scrMode === "A" || scrMode === "E") {
            setMsgTextYN('Do you really want to exit ?');
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }


    const cancelData = () => {
        setMsgBoxYN(false);
        setScrMode("");
    }

    const deleteConfirm = () => {
        let date = viewObj?.tfti_date;
        let currDate = new Date(date);
        let todayDate = new Date();
        const differenceInMilliseconds = todayDate - currDate;
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));

        const obj = {
            srno: srNo,
            type: 'FTI',
            pageright: 'FUND_TRANSFER_INTERNAL',
            location: 0
        }

        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setDeleteRemark("");
                setDeleteBoxYN(true);
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'FTI', trannumber: srNo, location: 0, tranDate: date });
            }
        });
    }

    const deleteData = () => {
        if (!deleteRemark.trim()) {
            setMsgBox(true);
            setMsgText("Please enter a remark for deletion.");
            return;
        }
        setDeleteBoxYN(false);
        const obj = {
            srno: srNo,
            remark: deleteRemark.trim(),
            location: 0,
            type: 'FTI'
        };
        Common.callApi(Common.apiTransferFundInternal, [sid, 'delete', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            if (resp.status) {
                setHeaderData(resp.data);
                setScrMode("");
                expireUnlock();
                setMsgBox(true);
                setMsgText(resp.msg);
            } else {
                setMsgBox(true);
                setMsgText(resp.msg);
            }
        });
    }

    const btnEditRequest = () => {
        const currDate = new Date();
        const newDate = viewDate.split('/');
        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0]
        const newCurrDate = Common.dateYMD(currDate);
        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);
        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;
        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
        console.log(differenceInDays);
        if (differenceInDays > 0) {
            const obj = {
                srno: srNo,
                type: 'FTI',
                pageright: 'FUND_TRANSFER_INTERNAL',
                location: 0
            }
            Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
                let resp = JSON.parse(result);
                setUnlockRequestType(resp.requestsrc);
                if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                    setScrMode('E');
                } else {
                    setShowEditRequest(true);
                    setEditLogObject({ trantype: 'FTI', trannumber: srNo, location: 0, tranDate: Common.dateYMD(currDate) });
                }
            })
        } else {
            setScrMode('E');
        }
    }
    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "FTI", trannumber: srNo, trancategory: "T", location: 0 });
    }

    const handleFaView = () => {
        setShowFaView(true);
        setFaViewObject({ location: "", trannumber: srNo, type: 'FTI' });
    }
    function statusUpdateHandler(status) {
        setStatusUpdate(status);
        //check maker and checker can not update status
        if (viewObj.tfti_created_by === sessionStorage.getItem('userSrno')) {
            setMsgBox(true);
            setMsgText("You can not update status (maker and status updater can not be same.)");
            return;
        }
        let fromBankArr = fromBank.id.split('^');
        let toBankArr = toBank.id.split('^');
        const obj = {
            status: status,
            srno: srNo,
            createdBy: viewObj.tfti_created_by,
            date: viewObj.tfti_date_ymd,
            amount: transactionAmount,
            fromBank: fromBank,
            toBank: toBank,
            fromGroup: fromBankArr[1],
            fromAccount: fromBankArr[2],
            toGroup: toBankArr[1],
            toAccount: toBankArr[2],
            refrenceNumber: refrenceNumber
        }
        Common.callApi(Common.apiTransferFundInternal, [sid, 'updateStatus', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            if (resp.status) {
                setHeaderData(resp.data);
                setScrMode("");
                setMsgBox(true);
                setMsgText(resp.msg);
            } else {
                setMsgBox(true);
                setMsgText(resp.msg);
            }
        });

    }
    const expireUnlock = () => {
        if (scrMode == 'E' && unlockRequestType !== "SELF") {
            const obj = {
                srno: srNo,
                type: 'FTI',
                status: 'E',
                currentDate: Common.dateYMD(new Date()),
                pageright: 'FUND_TRANSFER_INTERNAL'
            }
            Common.callApi(Common.apiUnlockEdit, [sid, 'expireUnlock', JSON.stringify(obj)], (result) => {
                console.log(result);
            });
        }
    }
    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Fund Transfer Internal</h3>
                    </Col>
                </Row>
                {scrMode === "" &&
                    <>
                        <Row>
                            <Col className='col-md-4 col-6'>
                                <Form.Group>
                                    <Row style={{ marginTop: "30px" }}>
                                        <Col>
                                            <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" />
                                        </Col><Col>
                                            <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                        </Col><Col>
                                            <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                        </Col>
                                    </Row>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            {radioType === 'N' &&
                                <>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Date<span className="text-danger">*</span></Form.Label>
                                            <DatePicker className="form-control"
                                                selected={transactionDate}
                                                minDate={new Date(startDate)}
                                                maxDate={new Date(endDate)}
                                                onChange={(date) => setTransactionDate(date)}
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                customInput={
                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                </>
                            }
                            {radioType === 'S' &&
                                <>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>From<span className="text-danger">*</span></Form.Label>
                                            <Form.Control value={fromSrno}
                                                maxLength={20}
                                                onChange={(e) => Common.validateNumValue(e.target.value, setFromSrno)}
                                                placeholder="From" />
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>To<span className="text-danger">*</span></Form.Label>
                                            <Form.Control value={toSrno}
                                                maxLength={20}
                                                onChange={(e) => Common.validateNumValue(e.target.value, setToSrno)}
                                                placeholder="To" />
                                        </Form.Group>
                                    </Col>
                                </>
                            }
                            {radioType === 'D' &&
                                <>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                            <DatePicker className="form-control"
                                                selected={filterFromDate}
                                                onChange={(date) => setFilterFromDate(date)}
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                customInput={
                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                            <DatePicker className="form-control"
                                                selected={filterToDate}
                                                onChange={(date) => setFilterToDate(date)}
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                customInput={
                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                </>
                            }
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col>
                                {
                                    userRight.add === "1" && radioType === 'N' ?
                                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addNew()}>Add New</Button> : null
                                }
                                &nbsp;
                                {
                                    userRight.query === "1" && (radioType === 'S' || radioType === 'D') ?
                                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={list}>List</Button>
                                        : null
                                }
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col>
                                <Table striped bordered hover size="sm">
                                    <thead>
                                        <tr>
                                            {userRight.query === "1" ? <th></th> : null}
                                            <th>SrNo</th>
                                            <th>From Bank</th>
                                            <th>To Bank</th>
                                            <th>Amount</th>
                                            <th>Date</th>
                                            <th>Status</th>
                                            <th>Remark</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            headerData?.map((res) => (
                                                <tr key={res.hdr_srno}>
                                                    {userRight.query === "1" ?
                                                        <td className="textCenter">
                                                            <span className="handCursor colorThemeBlue" onClick={() => viewList(res.tfti_srno)}>
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </span>
                                                        </td>
                                                        : null
                                                    }
                                                    <td style={{ textAlign: 'right' }}>{res.tfti_srno}</td>
                                                    <td>{res.tfti_from_bank}</td>
                                                    <td>{res.tfti_to_bank}</td>
                                                    <td style={{ textAlign: 'right' }}>{res.tfti_amount}</td>
                                                    <td >{res.tfti_date}</td>
                                                    <td>{res.tfti_status === 'P' ? 'Pending' : res.tfti_status === 'A' ? 'Approved' : res.tfti_status === 'R' ? 'Rejected' : 'Deleted'}</td>
                                                    <td>{res.tfti_remark || ''}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </>
                }
                {scrMode !== "" &&
                    <>
                        <Row>
                            <Col>
                                <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={() => cancelConfirm()}>Back</Button>{' '}
                                {
                                    (userRight.edit === "1" && scrMode === "Q" && viewObj?.tfti_status === 'P') ? <>
                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={btnEditRequest}>Edit</Button> &nbsp;
                                    </> : null
                                }
                                {(userRight.query === "1" && scrMode === 'Q') && <>
                                    <Button variant="outline-success" className='buttonStyle' size="sm" onClick={btnActivityLog}>Activity Log</Button>&nbsp;
                                    <Button variant="outline-success" className='buttonStyle' size="sm" onClick={handleFaView}>Fa View</Button>&nbsp;
                                </>}
                                {
                                    (userRight.edit === "1" && scrMode === "E") || (userRight.add === "1" && scrMode === "A") ? <>
                                        <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>
                                    </> : null
                                }
                                {/* <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={exportFile}>Export</Button> */}
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Label>Serial Number : {srNo}</Form.Label>
                            </Col>
                            <Col className='col-md-3 col-6'>
                                <Form.Label>Date : {viewDate}</Form.Label>
                            </Col>
                            {scrMode !== 'A' &&
                                <>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Status : {viewObj?.tfti_status === 'R' ? "Rejected" : viewObj?.tfti_status === 'A' ? "Approved" : viewObj?.tfti_status === 'D' ? "Deleted": "Pending"}</Form.Label>
                                    </Col>
                                    {viewObj?.tfti_status !== 'P' &&
                                        <Col className='col-md-3 col-6'>
                                            <Form.Label>Status Updated By : {viewObj?.status_updated_by || ''}</Form.Label>
                                        </Col>
                                    }
                                </>
                            }

                        </Row>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Total Amount</Form.Label>
                                    <Form.Control
                                        value={transactionAmount}
                                        placeholder="Total"
                                        type='number'
                                        disabled={scrMode === 'Q'}
                                        onChange={(e) => { setTransactionAmount(e.target.value) }} />
                                </Form.Group>
                            </Col>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>From Bank<span className="text-danger">*</span></Form.Label>
                                    <AsyncSelect
                                        cacheOptions={false}
                                        defaultOptions={false}
                                        value={fromBank}
                                        getOptionLabel={e => e.label + ' '}
                                        getOptionValue={e => e.id}
                                        isDisabled={scrMode === 'Q'}
                                        loadOptions={(search) => Picklist.fetchAllBankWithOutLocationPicklist(search)}
                                        onInputChange={Picklist.handleInputChange}
                                        onChange={handleFromBankChange}
                                    >
                                    </AsyncSelect>
                                </Form.Group>
                            </Col>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>To Bank<span className="text-danger">*</span></Form.Label>
                                    <AsyncSelect
                                        cacheOptions={false}
                                        defaultOptions={false}
                                        value={toBank}
                                        getOptionLabel={e => e.label + ' '}
                                        getOptionValue={e => e.id}
                                        isDisabled={scrMode === 'Q'}
                                        loadOptions={(search) => Picklist.fetchAllBankWithOutLocationPicklist(search)}
                                        onInputChange={Picklist.handleInputChange}
                                        onChange={handleToBankChange}
                                    >
                                    </AsyncSelect>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Refrence Number</Form.Label>
                                    <Form.Control value={refrenceNumber}
                                        maxLength={500}
                                        disabled={scrMode === 'Q'}
                                        onChange={(e) => setRefrenceNumber(e.target.value)}
                                        placeholder="Refrence Number" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            {/* {scrMode !== 'A' &&
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Status<span className="text-danger">*</span></Form.Label>
                                        <Form.Select value={statusUpdate} isDisabled={scrMode === 'Q'}
                                            onChange={e => setStatusUpdate(e.target.value)}
                                            required>
                                            <option value="">Select</option>
                                            <option value="P">Pending</option>
                                            <option value="A">Accept</option>
                                            <option value="R">Reject</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            } */}
                            {/* && viewObj?.tfti_status === 'P' */}
                            <Col>
                                <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={() => cancelConfirm()}>Back</Button> &nbsp;
                                {
                                    (userRight.edit === "1" && scrMode === "E") || (userRight.add === "1" && scrMode === "A") && <>
                                        <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>
                                    </>
                                }
                                {+userRight.delete === 1 && scrMode === "Q" && (viewObj?.tfti_status === "P" || viewObj?.tfti_status === "A") &&
                                    <>
                                        <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => deleteConfirm()}>Delete</Button> &nbsp;
                                    </>
                                }
                                {+userRightStatus.add === 1 && viewObj?.tfti_status === 'P' && scrMode === 'Q' && viewObj?.tfti_created_by !== +sessionStorage.getItem('userSrno') &&
                                    <>
                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => statusUpdateHandler('A')}>Approve</Button> &nbsp;
                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => statusUpdateHandler('R')}>Reject</Button> &nbsp;
                                    </>
                                }
                            </Col>
                        </Row>
                        <hr />
                        <Row>&nbsp;</Row>
                    </>
                }
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
            </Container>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <FaView faViewObject={faViewObject} show={showFaView} onHide={() => setShowFaView(false)} />
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <DialogYesNo isOpen={isMsgBoxYN} onYes={cancelData} onNo={() => setMsgBoxYN(false)}>
                    {msgTextYN}
                </DialogYesNo>
                <DialogYesNo isOpen={isDeleteBoxYN} onYes={deleteData} onNo={() => setDeleteBoxYN(false)}>
                    <div>Do you really want to delete this record?</div>
                    <Form.Group className="mt-2">
                        <Form.Control
                            as="textarea"
                            rows={2}
                            placeholder="Enter remark for deletion"
                            value={deleteRemark}
                            onChange={(e) => setDeleteRemark(e.target.value)}
                        />
                    </Form.Group>
                </DialogYesNo>
                <Dialog isOpen={isErrBox} onClose={(e) => setErrBox(false)}>
                    {errText}
                </Dialog>
                <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
            </div>
        </>
    )
}


export default FundTransferInternal;